import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  segmented: {
    width: 'fit-content',
    border: `1px solid ${token.colorBorder}`
  },
  select: {
    minWidth: 300
  },
  switch: {
    minWidth: 250
  },
  questionCard: {
    backgroundColor: token.lightGrey.lightGrey3,
    padding: 8,
    borderRadius: 8,
    border: `1px solid ${token.colorSplit}`
  },
  deleteButton: {
    minWidth: 32,
    height: 32
  },
  statsCard: {
    '.ant-card-body': {
      padding: 96
    }
  },
  quizTitle: {
    fontSize: '32px !important'
  },
  questionTitle: {
    fontSize: '20px !important'
  },
  progress: {
    '.ant-progress-text': {
      display: 'none'
    }
  },
  tag: {
    minWidth: 50
  }
}))
